<template>

    <div class="tags-wrapper" @click.prevent="onClick" :class="{ 'active' : (isFocused || vValue), 'activeoverlay' : (focusOverlay && !overlayInactive), 'w-hldr' : tagsCount > 0 }">

        <span class="placeholder">{{ placeholder }}</span>

        <tags-input
            ref="input"
            element-id="tags"
            v-model="selectedTags"
            :existing-tags="Global.assetsTags"
            :typeahead="true"
            :typeahead-activation-threshold="0"
            :typeahead-hide-discard="true"
            :only-existing-tags="false"
            :limit="3"
            :hide-input-on-limit="true"
            :typeahead-show-on-focus="true"
            :typeahead-always-show="forcedShow"
            @tag-added="onTagAdded"
            @tag-removed="onTagRemoved"
            @keydown="onKeyDown"
            @keyup="onKeyUp"
            @focus="onFocus"
            @blur="onBlur"
            @change="onChange"
            @input="onInput"
        >
        </tags-input>
    
    </div>

</template>

<script>
    import Global from '../lib/GlobalState'
    export default {

        name: 'AutoTagsWrapper',

        props: {
            placeholder: String,
            value: {
                type: Array,
                default: () => ([])
            }
        },

        data() {
            return {
                Global,
                inited: false,
                // isFocused: false,
                overlayInactive: false,
                isEmpty: true,
                vValue: null,
                focusOverlay: false,
                forcedShow: false,
                tagsCount: 0,
                selectedTags: []
            }
        },

        computed: {
            isFocused() {
                if (this.forcedShow || this.tagsCount > 0)
                    return true
                else
                    return false
            },
            cleanSelectedTags() {
                return this.selectedTags.map((tag) => {
                    return tag.value
                })
            }
        },

        created() {
            this.selectedTags = this.value.map((tag) => {
                return {key: tag.toLowerCase(), value: tag}
            })

            this.$nextTick().then(() => {
                this.inited = true
            })
        },

        methods: {

            onClick() {
                this.$refs.input.$el.getElementsByTagName('input')[0].focus()
            },

            onTagAdded() {
                this.tagsCount++
                // if(this.tagsCount >= 3) {
                //     this.onBlur()
                //     return
                // }
                this.onClick()
            },

            onTagRemoved() {
                this.tagsCount--
            },

            onKeyDown(event) {
            },

            onKeyUp() {
                let el = this.$refs.input.$el.getElementsByClassName('typeahead-badges')[0]
                this.vValue = this.$refs.input.$el.getElementsByTagName('input')[0].value

                if(el.parentNode.style.display == 'none')
                    this.overlayInactive = true
                else
                    this.overlayInactive = false
            },

            onFocus() {
                this.focusOverlay = true
                this.forcedShow = true
            },
            
            onBlur() {
                this.focusOverlay = false
                this.forcedShow = false
            },

            onChange(value) {
            },

            onInput() {
                if(this.inited) {
                    this.$emit('input', this.cleanSelectedTags)
                }
            }
        }
    }

</script>